import { HttpErrorResponse } from '@angular/common/http';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import {
  ColumnSizes,
  List,
  Pagination,
  Sorting,
} from 'libs/wflow-cdk/src/public-api';
import { PanelFilterState } from 'libs/wflow-ui/src/public-api';
import { PeppolRejectRequest } from '../../../interfaces/peppol-item.dto';
import { PeppolItem } from '../../../interfaces/peppol-item.interface';
import { PeppolListScope } from '../peppol-items.interface';

export const peppolItemsPageEvents = eventGroup({
  source: 'Peppol Items Page',
  events: {
    initialized: type<{ storageKeyPrefix: string; scope: PeppolListScope }>(),
    searchChanged: type<string>(),
    filtersChanged: type<PanelFilterState>(),
    paginationChanged: type<Pagination>(),
    sortChanged: type<Sorting>(),
    columnSizesChanged: type<ColumnSizes>(),
    actionInvoked: type<{ action: string; item: PeppolItem }>(),
    rejectConfirmed: type<{ item: PeppolItem; request: PeppolRejectRequest }>(),
    createDocumentConfirmed: type<{ item: PeppolItem; typeId: string }>(),
  },
});

export const peppolItemsApiEvents = eventGroup({
  source: 'Peppol Items API',
  events: {
    storageHydrated: type<{
      pagination: Pagination;
      filters: PanelFilterState;
    }>(),
    columnSizesLoaded: type<ColumnSizes | null>(),
    itemsLoadStarted: type<void>(),
    itemsLoaded: type<List<PeppolItem>>(),
    itemsLoadFailed: type<{ error: HttpErrorResponse }>(),
    actionSucceeded: type<{ action: string }>(),
    actionFailed: type<{ action: string; error: HttpErrorResponse }>(),
  },
});
